import { Modal, Form, Input, Button, Row, Col, Divider, Typography } from "antd";
import { useEffect } from "react";

const { Text } = Typography;

const RoleModal = ({ isModalShow, handleCancel, onFinish, submitLoading, edit, initialValues }) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (edit && initialValues) {
            form.setFieldsValue({ ...initialValues });
        } else {
            form.resetFields();
        }
    }, [edit, initialValues, form]);

    return (
        <Modal
            title={<div style={{ width: "100%" }}>{edit ? "Edit Role" : "Add Role"}</div>}
            open={isModalShow}
            onCancel={handleCancel}
            footer={null}
            closable={true}
            width={700}
            style={{ padding: "15px" }}
        >
            <Divider />
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Role"
                            name="title"
                            rules={[{ required: true, message: "Please enter title" }]}
                        >
                            <Input
                                type="text"
                                placeholder="Enter Role Title"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    const formattedVal = val.toLowerCase().replace(/\s+/g, '-');
                                    form.setFieldsValue({ name: formattedVal });
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label={<Text>Slug <span style={{ color: '#87CEEB' }}>(read only)</span></Text>}
                            name="name"
                        >
                            <Input type="text" placeholder="Read Only" disabled />
                        </Form.Item>
                    </Col>

                    <Col span={24} style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={submitLoading}
                            >
                                {edit ? "Update" : "Add"}
                            </Button>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default RoleModal;
